const sizes = {
  square: 0.908,
  // ish
  landscape: 0.667,
  letterbox: 0.425,
  portrait: 1.299
};

/**
 * Our standardised image sizes.
 *
 * Includes mapping to the original WP keys, as well as the more succinct
 * versions defined above.
 */
export const imageSizes = Object.freeze({
  ...sizes,
  landscape_thumbnail: sizes.landscape,
  portrait_thumbnail: sizes.portrait,
  square_thumbnail: sizes.square,
  letterbox_image: sizes.letterbox,
  // The `dynamic` option is a special case for when we want to set the aspect
  // ratio dynamically from the width and height of the image.
  dynamic: null
});